// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"dde32995","488":"6906bc7e","953":"8b7ad708"}[chunkId] + ".chunk.js";
};